/** A referential list: no tenant, no parameter. */
class FetchSubjectTypeColors {
	constructor() {
		Object.freeze(this);
	}
}

export default FetchSubjectTypeColors;
